export default __webpack_public_path__ + "static/media/product_14.683c34ca.png";